import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { callApi, getInlineLoader } from "../Helpers";
import { STR_BUSINESS_NAME, STR_BUSINESS_TYPE, STR_CLIENT_LEVEL, STR_COMPANY, STR_CONTACT_US, STR_CUSTOMER, STR_EMAIL_ADDRESS, STR_GET_FREE_TRIAL, STR_INVALID_BUSINESS_NAME, STR_INVALID_NAME, STR_INVALID_NAME_2, STR_INVALID_PHONE_2, STR_LEAD, STR_NAME, STR_OPTIONAL, STR_PHONE_NUMBER, STR_PHYSICAL_ADDRESS, STR_POBOX, STR_REGISTER_BUSINESS, STR_REGISTER_CLIENT, STR_REGISTER_VENDOR, STR_SOLE_PROPRIETOR, STR_SUBMIT, STR_SUCCESS, STR_TIN, STR_VRN, STR_WEBSITE_URL, STR_WHATSAPP_NUMBER, STR_WITH_COUNTRY_CODE } from "../Strings";
import MobileInterface from "../MobileInterface";

import { FaTelegram, FaWhatsapp } from "react-icons/fa";
import { MdCall, MdEmail } from "react-icons/md";
import NapaAddressPicker from "../ones/NapaAddressPicker";


export default function ContactUs(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);

	const [name, setName] = useState('');
	const [physicalAddress, setPhysicalAddress] = useState({});
	const [resetNapaPicker, setResetNapaPicker] = useState(false);
	const [pobox, setPobox] = useState('');
	const [phone, setPhone] = useState('');
	const [email, setEmail] = useState('');
	const [ tin, setTin ] = useState('');
	const [vrn, setVrn] = useState('');

	async function init() {
		//run initializations here
		setReady(false);
		//..
		setReady(true);
	}

	function resetForm() {
		setName('');
		setPobox('');
		setPhone('');
		setEmail('');
		setTin('');
		setVrn('');

		setResetNapaPicker(true);
		setTimeout(() => {
			setResetNapaPicker(false);
		}, 1000)
	}

	async function submit() {
		if(name.trim().length > 0) {
			setLoading(true);
			await callApi(
				'register-vendor',
				{
					name,
					physicalAddress: JSON.stringify(physicalAddress),
					pobox,
					phone,
					email,
					tin,
					vrn,
					businessUuid: appContext?.currentBusiness?.businessUuid
				}
			).then(response => {
				if(response.status === 1) {
					appContext.tellMessage(STR_SUCCESS[appContext.language]);
					resetForm();
					appContext.getAllVendors();
					appContext.navBack();
				} else {
					appContext.tellError(response.msg);
				}
			})
			setLoading(false);
			
		} else {
			appContext.tellError(STR_INVALID_NAME_2[appContext.language]);
		}
	}

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	if (ready) {
		return (
			<div
				style={{
					width: "100%",
					height: "100%",
					overflow: "scroll",
					paddingTop: "20px",
				}}
				className="mNoScrollBar"
			>
				<div className="container">

					<div className="row">

						<div className="col-md-12">
							<h6 className="main-section-title">
								{STR_REGISTER_VENDOR[appContext.language]}
							</h6>
						</div>

						
						<div className="col-md-12 mt-3 mb-3">
							<label className="form-label">{STR_NAME[appContext.language]}</label>
							<input
								className="form-control"
								value={name}
								onChange={(e) => setName(e.target.value)}
							/>
						</div>
						

						<div className="col-md-6 mt-3 mb-3">
							<label className="form-label">{STR_PHONE_NUMBER[appContext.language]}</label>
							<input
								className="form-control"
								onChange={(e) => setPhone(_prev => {
									if (Number(e.target.value)) {
										return Number(e.target.value);
									} else if (String(e.target.value).trim().length === 0) {
										return "";
									} else {
										return _prev;
									}
								})}
								value={phone}
								maxLength={15}
								placeholder="255XXXXXXXXX"
								type="text"
								
							/>
							<div className="form-text">
								<span className="font-semi-bold">{STR_OPTIONAL[appContext.language]}</span> | {STR_WITH_COUNTRY_CODE[appContext.language]}
							</div>
						</div>

						

						<div className="col-md-6 mt-3 mb-3">
							<label className="form-label">{STR_EMAIL_ADDRESS[appContext.language]}</label>
							<input
								className="form-control"
								value={email}
								onChange={(e) => setEmail(e.target.value)}
							/>
							<div className="form-text">
								{STR_OPTIONAL[appContext.language]}
							</div>
						</div>

						<div className="col-md-6 mt-3 mb-3">
							<label className="form-label">{STR_TIN[appContext.language]}</label>
							<input
								className="form-control"
								value={tin}
								onChange={(e) => setTin(e.target.value)}
							/>
							<div className="form-text">
								{STR_OPTIONAL[appContext.language]}
							</div>
						</div>

						<div className="col-md-6 mt-3 mb-3">
							<label className="form-label">{STR_VRN[appContext.language]}</label>
							<input
								className="form-control"
								value={vrn}
								onChange={(e) => setVrn(e.target.value)}
							/>
							<div className="form-text">
								{STR_OPTIONAL[appContext.language]}
							</div>
						</div>

						<div className="col-md-6 mt-3 mb-3">
							<label className="form-label">{STR_POBOX[appContext.language]}</label>
							<input
								className="form-control"
								value={pobox}
								onChange={(e) => setPobox(e.target.value)}
							/>
							<div className="form-text">
								{STR_OPTIONAL[appContext.language]}
							</div>
						</div>

						<div className="col-md-12 mt-3 mb-3">
							<label className="form-label">{STR_PHYSICAL_ADDRESS[appContext.language]}</label>
							<div className="form-text">
								{STR_OPTIONAL[appContext.language]}
							</div>
							<NapaAddressPicker resetNow={resetNapaPicker} callback={setPhysicalAddress}/>
							
						</div>

						<div className="col-md-12 mt-3 mb-5">
							<button
								className="btn btn-block btn-padded btn-rounded btn-secondary"
								onClick={submit}
							>
								{STR_SUBMIT[appContext.language]}
							</button>
						</div>

					</div>

				</div>


			</div>
		)
	} else {
		return (
			<div
				className="mSupportLoading"
				style={{
					width: "100%",
					height: "100%",
				}}
			>
				{getInlineLoader()}
			</div>
		);
	}


}